<template>
    <div class="employee-block" v-if="visible && postData">  
            <div class="inner" v-if="postData.featured_media && postData.featured_image_src && postData.featured_image_src.url">
                <wpImage 
                    v-if="postData.featured_image_src && !size"
                    :data="postData.featured_image_src" 
                    size="large"
                    class="empl-image-bg"
                    background
                    lazy
                />
                <wpImage 
                    v-if="postData.featured_image_src && size"
                    :data="postData.featured_image_src" 
                    :size="size"
                    class="empl-image-bg"
                    background
                    lazy
                />
                <h4 class="employee-title">{{postData.title.rendered}}</h4>
                <p class="position" v-html="postData.acf.info.position"></p>
                <p><a :href="'mailto:'+postData.acf.info.email">{{postData.acf.info.email}}</a></p>
                <p><a :href="'tel:'+postData.acf.info.phone">{{postData.acf.info.phone}}</a></p>
            </div>
            <div v-else-if="!postData.featured_media && !postData.featured_image_src">
                <div class="no-image">
                    <figure class="image-hold empl-image-bg background-image">
                        <div class="wp-image lazyloading">
                            <div class="bg-image lazyloaded" :style="'background-image: url('+iconUrl+');'">
                            </div>
                        </div>
                    </figure>
                </div>
                <h4 class="employee-title">{{postData.title.rendered}}</h4>
                <p class="position" v-html="postData.acf.info.position"></p>
                <p><a :href="'mailto:'+postData.acf.info.email">{{postData.acf.info.email}}</a></p>
                <p><a :href="'tel:'+postData.acf.info.phone">{{postData.acf.info.phone}}</a></p>
            </div>
    </div>
    <postBlockLoader v-observe-visibility="{
        callback: checkVisibility,
        intersection: {
            rootMargin: '100px 0px 0px 0px',
            threshold: 0
        }
        }" v-else />
</template>

<script>

import postBlockLoader from '@/components/loaders/postBlock'
import wpLink from '@/components/navigation/WpLink'
import wpImage from '@/components/elements/WpImage'

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'employee-image-block',
    props: ['id', 'type','size'],
    components: {
        postBlockLoader,
        wpImage
    },
    data(){
        return{
            visible: false,
            loading: false,
            homeUrl: window.WPVUE.home_url,
        }
    },
    computed: {
        ...mapGetters([
            'getPostById'
        ]),
        postData(){
            const postType = this.type || 'employees'
            const postId = this.id
            
            let post = this.getPostById( postId )
            if(!post && !this.loading){
                this.loading = true
                this.loadPostById({ id: postId, postType } )
            }
            return post
        },
        linkUrl(){
			if(this.postData.link && this.postData.link !== ''){
				return this.postData.link.replace(this.homeUrl, '');
			}else return '';
        },
        iconUrl() {
            return require('@/assets/user.svg')
            // The path could be '../assets/img.png', etc., which depends on where your vue file is
        }
    },
    methods: {
        ...mapActions([
            'loadPostById'
        ]),
        checkVisibility(vis, el){
            if(vis && !this.visible) {
                this.visible = true
            }
        }
    },
}
</script>